import * as React from 'react';
import {connect} from 'react-redux';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {HistoryCollisionSelectors} from 'Redux/Selectors/CollisionSelectors';
import {CarSpeedDataframeDtoWithDiff, SpeedDataframeForCharts} from '../../Models/CollisionModel';

const ReactHighcharts = require('react-highcharts');

import {withTranslation} from 'react-i18next';
import moment from 'moment';
import {tooltip} from "leaflet";

type Props = {
    history?: any,
    t?: any
};

type ConnectedProps = {
    speedData: SpeedDataframeForCharts,
    crashMoment: moment.Moment,
    activeSpeedDataframeWithDiff: CarSpeedDataframeDtoWithDiff
};


class HistoryCharts extends React.PureComponent<Props & ConnectedProps, any> {

    public render() {
        return (
            <div className="historyCharts">
                {
                    <ReactHighcharts
                        config={this.getConfig(this.props.speedData)} isPureConfig={true}
                    />
                }
            </div>
        );
    }

    private formatCallback = function () {
        if ((parseInt(this.value, 10) % 2)) {
            return '';
        }

        return this.value;
    };

    private tooltipFormat = () => <div>
        cuj
    </div>;

    private getConfig(speedData: SpeedDataframeForCharts): Highcharts.Options {

        const {activeSpeedDataframeWithDiff} = this.props;
        const dateTimeDiff = (activeSpeedDataframeWithDiff) ? activeSpeedDataframeWithDiff.dateTimeDiff : -10;

        return {
            chart: {
                zoomType: 'xy',
                animation: false
            },
            plotOptions: {
                series: {
                    animation: false
                }
            },
            title: {
                text: '1',
                style: {
                    color: 'white'
                }
            },
            xAxis: [{
                type: 'datetime',
                title: {
                    style: {
                        color: "blue"
                    }
                },
                labels: {
                    enabled: true,
                    formatter: this.formatCallback,
                },
                // min:-10,
                // max:10,
                crosshair: false,
                tickInterval: 1,
                plotBands: [{
                    color: 'rgba(0,0,0,0.3)', // Color value
                    from: -100, // Start of the plot band
                    to: dateTimeDiff // End of the plot band
                }],
                plotLines: [{
                    color: 'green', // Color value
                    value: dateTimeDiff, // Value of where the line will appear
                    width: 6 // Width of the line
                },
                    {
                        color: 'yellow', // Color value
                        value: 0, // Value of where the line will appear
                        width: 6, // Width of the line
                        label: {
                            text: `${this.props.t('carCollision')}`
                        }
                    }],
            }],
            yAxis: [
                { // Secondary yAxis
                    gridLineWidth: 1,
                    min: 0,
                    title: {
                        text: `${this.props.t('velocity')} [km/h]`,
                        style: {
                            color: "blue"
                        }
                    },
                    labels: {
                        format: '{value}',
                        style: {
                            color: "blue"
                        }
                    }
                },
                { // Primary yAxis
                    min: 0,
                    title: {
                        text: `${this.props.t('acceleration')} [m/s2]`,
                        style: {
                            color: "red"
                        }
                    },
                    labels: {
                        format: '{value}',
                        style: {
                            color: "red"
                        }
                    },
                    opposite: true
                }
            ],
            tooltip: {
                shared: true
            },
            series: [
                {
                    name: this.props.t('acceleration'),
                    type: 'spline',
                    yAxis: 1,
                    color: "red",
                    data: speedData.accelerations,
                },
                {
                    name: this.props.t('velocity'),
                    type: 'spline',
                    color: "blue",
                    data: speedData.speeds,
                }
            ],
            legend: {
                layout: 'horizontal',
                align: 'left',
                x: 0,
                verticalAlign: 'top',
                y: 0,
                floating: true,
                backgroundColor: 'rgba(255,255,255,0.25)'
            },
        }


    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        speedData: HistoryCollisionSelectors.getSpeedDataForCharts(state),
        crashMoment: state.historyCollision.crashMoment,
        activeSpeedDataframeWithDiff: HistoryCollisionSelectors.getActiveSpeedDataframeWithDiff(state)
    };
}

export default withTranslation(['reports'])(connect(
    mapStateToProps,
    null
)(HistoryCharts) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/History/HistoryCharts.tsx